import PropTypes from 'prop-types';

export default function forker(state) {
  return {
    fork(handler) {
      const { themes, active } = state;
      const instance = state.factory(themes, active);

      if (typeof(handler) === 'function') {
        instance.subscribe(handler.bind(this, instance));
      }

      return instance;
    },
  };
}

forker.stateTypes = {
  active: PropTypes.string.isRequired,
  factory: PropTypes.func.isRequired,
  themes: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
};
